import tw from 'twin.macro';

// Template container box.
const Container = tw.div`select-none w-80 h-32 rounded-lg`;

export default Container;
